import { render, staticRenderFns } from "./DemoDetails.vue?vue&type=template&id=17b3a8c9&"
import script from "./DemoDetails.vue?vue&type=script&lang=ts&"
export * from "./DemoDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports